import { render, staticRenderFns } from "./learnCategoryCard.vue?vue&type=template&id=cf04900a&"
import script from "./learnCategoryCard.vue?vue&type=script&lang=js&"
export * from "./learnCategoryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports